import useUser from '@admin/models/User'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import Table from '@modules/Table'
import useTitle from '@hooks/useTitle'
import MainContainer from '@blocks/MainContainer'
import { capitalize } from 'lodash'
import React from 'react'
import { useParams } from 'react-router'
import columns from './config/columns'

export default function UserPage() {
    const { id } = useParams<{ id: string }>()
    const user = useUser(id)
        
    useTitle(`User: ${user.attrs.name()}`)

    if (!user.state)
        return null
    
    return (
        <MainContainer heading={user.attrs.name()}>
            <Grid>
                <EmphasizedContent>
                    <Grid gap="5px">
                        <small>Role</small>
                        <h4>{capitalize(user.state.role)}</h4>
                    </Grid>
                </EmphasizedContent>
                <Table data={user.state.activity} columns={columns} />
            </Grid>
        </MainContainer>
    )
}